export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-format/src/identity.js
// module id = x+9z
// module chunks = 0